import { axiosInstance } from './api';
import * as ActionTypes from '../store/ActionTypes';

export const actionCreators = {
    getLocations: (locations) => ({ type: ActionTypes.getLocations, payload: locations }),
    getLocation: (location) => ({ type: ActionTypes.getLocation, payload: location }),
    updateLocation: (location) => ({ type: ActionTypes.updateLocation, payload: location }),
    createLocation: (location) => ({ type: ActionTypes.createLocation, payload: location }),
    setLocation: (location) => ({ type: ActionTypes.getLocation, payload: location }),
    updateResponse: (response) => ({ type: ActionTypes.updateResponse, payload: response }),
    getAllBranches: (branches) => ({ type: ActionTypes.getAllBranches, payload: branches }),
    getStateProvinces: (stateProvinces) => ({ type: ActionTypes.getStateProvinces, payload: stateProvinces }),
    setPagination: (state) => ({ type: ActionTypes.paginationLocation, payload: state })
}


export const getLocations = (callback, context, filter) => {
    return dispatch => {
        const url = `Location/SearchLocations?filter=${filter}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getLocations(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getLocation = (callback, context, id) => {
    return dispatch => {
        const url = `Location/GetLocationById/${id}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getLocation(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getLocationsPaginated = (filter, pageNumber, pageSize, orderBy, descending) => {
    const url = `Location/SearchLocationsPaginatedAsync?filter=${filter}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&descending=${descending}`;
    return axiosInstance().get(url);
}

export const getAllBranches = (callback, context) => {
    return dispatch => {
        const url = `Branch/GetAllBranches`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.updateLocation(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getStateProvinces = (callback, context) => {
    return dispatch => {
        const url = `StateProvince/GetStateProvincesAsync`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.updateLocation(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const updateLocation = (location) => {
    return dispatch => {
        const url = `Location/PutAsync`;
        return axiosInstance().put(url, location).then(response => {
            dispatch(actionCreators.updateLocation(response))
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const updateResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateResponse(response));
    }
}

export const createLocation = (location) => {
    return dispatch => {
        const url = `Location/PostAsync`;
        return axiosInstance().post(url, location).then(response => {
            dispatch(actionCreators.updateLocation(response))
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}


export const setStatePagination = (state) => {
    return dispatch => {
        dispatch(actionCreators.setPagination(state));
    }
}